import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { resolveUrl } from './utils/resolveUrl'
import i18n from './i18n'
import { localeStore } from './store/locale'

localeStore.init()

const app = createApp(App)

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 0.2,
    environment: process.env.NODE_ENV || 'development'
  })
}

app.config.globalProperties.$resolveUrl = resolveUrl
app.use(router).use(i18n).mount('#app')
